import { Container, Typography } from "@mui/material";

export const Dashboard = () => {
  return (
    <Container maxWidth="lg">
      <Typography
        component={"h1"}
        variant="h5"
        fontWeight={"bold"}
        gutterBottom
      >
        대시보드
      </Typography>
    </Container>
  );
};
